export default __webpack_public_path__ + "static/media/dwarf.356df808.png";